import { AdminRoutes, MainContainer, XAccountHolder } from 'src/components'
import { AddressAndBalanceHolder } from 'src/components/address-and-balance-holder'

const AdminRoutesScreen = () => {
  return (
    <MainContainer headerTitle={'Trackgood Admin'}>
      <AddressAndBalanceHolder />
      <XAccountHolder />
      <AdminRoutes />
    </MainContainer>
  )
}

export default AdminRoutesScreen
